import React from "react"
import {KlassDropdown, KlassDropdownProps} from "../Select"
import {TERM_ENROLL_STATUS_OPTIONS} from "types/students"

type Props = Partial<KlassDropdownProps> & {}

export const TermEnrollStatusSelect: React.FC<Props> = ({...props}) => {
    return <KlassDropdown {...props} options={TERM_ENROLL_STATUS_OPTIONS} />
}
